<template>
  <div class="Details" :style="listHeight">
    <el-scrollbar style="height:100%;">
      <div v-for="item in rootData" :key="item.ID">
        <el-row>
          <el-col :span="22">
            <div class="username">{{item.CREATEUSERNAME}}</div>
            <div class="time">{{item.CREATETIME|timeFormater}}</div>
          </el-col>
          <el-col :span="2">
            <div class="title">
              <div class="iconfont icon-liaotian" style="color: #409eff;cursor:pointer" @click="reply(item)"></div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="abstract">{{item.CONTENT}}</div>
          </el-col>
        </el-row>
        <el-row v-for="item1 in parentData(item.ID)" :key="item1.ID">
          <el-col :span="3">
            <div class="username"><img src="@/assets/img/subordinate.png" /></div>
          </el-col>
          <el-col :span="21">
            <div class="title">
              <el-row>
                <el-col :span="24">
                  <div class="username">{{item1.TOUSERNAME}}</div>
                  <div class="time">{{item1.CREATETIME|timeFormater}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="username1">回复@{{item1.CREATEUSERNAME}}:</div>
                  <div class="abstract">{{item1.CONTENT}}</div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div>
                    <el-row>
                      <el-col :span="22">
                        <div class="username">许跃林</div>
                        <div class="time">10月19日 14:55</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="title">
                          <div class="iconfont icon-liaotian" style="color: #409eff;cursor:pointer" @click="reply"></div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="abstract">这里是评论详情信息。支持纯文本显示，</div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="username"><img src="@/assets/img/subordinate.png" /></div>
                      </el-col>
                      <el-col :span="21">
                        <div class="title">
                          <el-row>
                            <el-col :span="24">
                              <div class="username">张睿文</div>
                              <div class="time">10月19日 14:55</div>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="24">
                              <div class="username1">回复@许跃林:</div>
                              <div class="abstract">这里是评论详情信息。支持纯文本显示，</div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
          -->
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" :placeholder="contentPlaceholder" v-model="content" @keydown.ctrl.13.native="onSubmit" clearable>
        </el-input>
        <div class="button">
          <!-- <el-upload  class="upload-demo" action="http://localhost:8080" :limit='5' :on-exceed="exceedUpload" :auto-upload="true" :before-upload="beforeUpload " :on-change='handleChange' :file-list="FileList">
    						<el-button size="small" type="primary" class="repairs_submit">添加附件</el-button>
    					</el-upload> -->
          <el-button size="mini" @click="onCancel">取消</el-button>
          <el-button type="primary" size="mini" @click="onSubmit">发送</el-button>
        </div>
        <!-- <el-input :placeholder="contentPlaceholder" v-model="content" @keydown.ctrl.13.native="onSubmit" clearable></el-input> -->
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  import {
    mapState,
  } from 'vuex'
  import {
    getToken
  } from '@/util/auth'
  import {
  AddCrisitism,
  GetCrisitismByMainId
  } from "@/api/modules/basicData/task";
  export default {
    data() {
      return {
        content: '',
        contentPlaceholder: '评价内容(Crtl+Enter)',
        cookieUser: {},
        sreplenishData: [],
        rootData: [],
        crisitisminfo: {},
      }
    },
		created() {
			let a = $(window).height();
			this.listHeight = "height:" + (a - 150) + "px;";
		},
    methods: {
      initalTask: function() {
        if (!this.task || this.tabIndex !== '1') return;
      GetCrisitismByMainId(this.task.ID, 0).then(pmevent => {
          if (!pmevent) return;
          this.sreplenishData = pmevent;
          this.rootData = pmevent.filter(item => item.ROOTID === null)
        });
      },
      parentData: function(ID) {
        return this.sreplenishData.filter(item => item.PID === ID)
      },
      reply: function(item) {
        this.contentPlaceholder = '回复' + item.CREATEUSERNAME + '(Crtl+Enter)';
        this.crisitisminfo = item;
      },
      isShowReply: function(item) {
        const user = getToken();
        return user.userId === item.CREATEUSERID
      },
      onCancel: function() {
        this.content = '';
        this.contentPlaceholder = '评价内容(Crtl+Enter)';
        this.crisitisminfo = {};
      },
      onSubmit: function() {
        if (!this.content) return;
        const date = new Date();
        const user = getToken();
        let par = {
          GUID:this.Guid(),
          CONTENT: this.content,
          CREATETIME: date,
          CREATEUSERID: user.userId,
          CREATEUSERNAME: user.realName,
          CREATEDEPTID: user.departmentId,
          CREATEDEPTNAME: "",
          MAINID: this.task.ID,
          MAINTYPE: 0,
          CREATECOMPANYID: user.organizationId,
          CREATECOMPANYNAME: "",
        }
        if (Object.keys(this.crisitisminfo).length > 0) {
          par.PID = this.crisitisminfo.ID;
          par.ROOTID = this.crisitisminfo.ID;
          par.TOUSERID = user.userId;
          par.TOUSERNAME = user.realName;
          par.TODEPTID = user.departmentId;
          par.TODEPTNAME = "";
          par.CREATEUSERNAME = this.crisitisminfo.CREATEUSERNAME;
        }
      AddCrisitism(par,true).then(pmevent => {
          if (pmevent === 1) {
            this.content = '';
            this.initalTask();
            this.$message({
              type: 'success',
              message: '添加补充说明成功。'
            });
          } else {
            this.$message({
              type: 'error',
              message: '添加补充说明失败！'
            });
          }
        });
      },
      Guid: function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }
    },
    computed: {
      // ...mapState({ task: state => state.task.curTask}),
      task: function() {
        return this.$store.state.task.curTask;
      },
      tabIndex: function() {
        return this.$store.state.task.tabIndex;
      },
    },
    watch: {
      task: function(newvalue) {
        if (!newvalue) return;
        this.initalTask();
      },
      tabIndex: function(newvalue) {
        if (!newvalue) return;
        this.initalTask();
      }
    }
  };
</script>

<style scoped>
  .button {
    margin: 10px 0 0 20px;
  }
  .content {
    text-align: right;
  }
  .el-row {
    margin-bottom: 5px;
  }
  .el-col {
    border-radius: 4px;
    text-align: left;
  }
  .Details {
    margin: 21px 30px 0px 30px;
  }
  .title {
    text-align: left;
    font-family: MicrosoftYaHei-Bold;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #303030;
  }
  .abstract {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #3a3a3a;
  }
  .tagtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #858585;
  }
  .username {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #409eff;
    float: left;
  }
  .username1 {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #a0a0a0;
    float: left;
  }
  .time {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #909399;
    line-height: 20px;
    float: left;
    margin-left: 15px;
  }
</style>